exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.friend-search-bar{\n    margin-left:60px;\n    margin-right:60px;\n}\n.friends-search-list{\n    margin-top:30px;\n    margin-left:60px;\n    margin-right:60px;\n    display:flex;\n    flex-flow: row wrap;\n    justify-content: space-between;\n}\n@media only screen and (max-width: 600px) {\n    .friend-search-bar{\n        margin-left: 3vw;\n        margin-right: 3vw;\n        margin-top:3vw;\n    }\n    .friends-search-list{\n        margin-top:3vw;\n        margin-left:3vw;\n        margin-right:3vw;\n        flex-direction:column;\n    }\n}", ""]);

// exports
